import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";
import getMinMaxPriceForType from "@SearchResults/features/staticContent/functions/getMinMaxPriceForType";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";
import CompanyType from "@SearchResults/types/company/Company.type";

interface HowMuchContentProps {
    departure: string,
    destination: string,
    singleRoutes: RoutesOrganizedByTransportTypeType,
    companies: Record<string, CompanyType>
    cheapestVehClass: TransportTypesType,
    priciestVehClass: TransportTypesType,
}

function HowMuchContent(props: HowMuchContentProps) {
    const {
        departure,
        destination,
        singleRoutes,
        companies,
        cheapestVehClass,
        priciestVehClass,
    } = props

    const priciestVehClassTranslation = getTranslationFromTransportType(priciestVehClass)
    const cheapestVehClassTranslation = getTranslationFromTransportType(cheapestVehClass)

    const {max: priciestPrice} = getMinMaxPriceForType(singleRoutes[priciestVehClass])
    const {min: cheapestPrice, cheapestCompanyId} = getMinMaxPriceForType(singleRoutes[cheapestVehClass])

    const cheapestOperator = companies[cheapestCompanyId].name

    const title = useTranslation(
        `${multiModalTranslationKey}.how_much_cost.title`,
        {departure, destination}
    )

    const description = useTranslation(
        `${multiModalTranslationKey}.how_much_cost.desc1`,
        {
            departure,
            destination,
            cheapestVehClass: cheapestVehClassTranslation,
            cheapestPrice,
            cheapestOperator,
            priciestVehClass: priciestVehClassTranslation,
            priciestPrice,
        }
    )

    return (
        <TitleAndContent
            title={title}
            content={description}
        />
    )
}

export default HowMuchContent